import { render, staticRenderFns } from "./DesignUpdateLayout.vue?vue&type=template&id=929499c6&scoped=true&"
import script from "./DesignUpdateLayout.vue?vue&type=script&lang=js&"
export * from "./DesignUpdateLayout.vue?vue&type=script&lang=js&"
import style0 from "./DesignUpdateLayout.vue?vue&type=style&index=0&id=929499c6&prod&lang=css&"
import style1 from "./DesignUpdateLayout.vue?vue&type=style&index=1&id=929499c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929499c6",
  null
  
)

export default component.exports